<template>
    <VJoyPanel class="additional-notes-panel">
        <template #panel-title>{{ $t('projectclient.quote.view.additional-notes.title') }}</template>
        <template #panel-body>
            <template v-if="richContentParsed">
                <ShowMoreTextContent class="joy-mt-2" :lines="3">
                    <template #text-content>
                        <p v-html="richContentParsed"></p>
                    </template>
                </ShowMoreTextContent>
            </template>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {VJoyPanel} from '@maltjoy/core-vue';
    import ShowMoreTextContent from '~/common/ui/ShowMoreTextContent.vue';
    import {useMarkdownToHtml} from '~/common/utils';
    import type {FixedPriceQuoteResource} from '~/openapi';

    const props = defineProps<{
        quote?: FixedPriceQuoteResource;
    }>();

    const {markdownToHtml} = useMarkdownToHtml();

    const richContentParsed = markdownToHtml(props.quote?.details.additionalNotes) ?? '-';
</script>
